/**
 * Listens for whisper transcription progress events from Electron
 * and updates the active transcription job in MediaContext.
 * Renders nothing — pure side-effect component.
 *
 * Follows the VettingToastListener pattern.
 */

import { useEffect } from 'react';
import { useMedia } from '../../contexts/MediaContext';

export function TranscriptionProgressListener() {
  const { state, updateJob } = useMedia();

  useEffect(() => {
    if (!window.electronWhisper?.onTranscribeProgress) return;

    const unsubscribe = window.electronWhisper.onTranscribeProgress((data) => {
      // Find the active (processing/pending) transcription job
      const activeJob = Array.from(state.transcriptionJobs.values())
        .find(j => j.status === 'pending' || j.status === 'processing');

      if (!activeJob) return;

      if (data.status === 'loading' || data.status === 'transcribing') {
        updateJob(activeJob.id, { status: 'processing', progress: data.progress });
      }
      // 'complete' and 'error' are handled by the IPC invoke return in TranscribeTool
    });

    return unsubscribe;
  }, [state.transcriptionJobs, updateJob]);

  return null;
}
